module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/consultant-kagami-423f7ae8e493ce460489d6b025115c5d.png";